import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const ImporterExporterCodeIndia = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />
      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Importer Exporter Code India
      </div>
      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        The Importer Exporter (IE) Code, issued by the Directorate General of
        Foreign Trade (DGFT) under the Ministry of Commerce and Industries, is a
        mandatory registration for businesses engaging in import and export
        activities with the Indian Customs department.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Regulatory Framework */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Regulatory Framework
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
                marginBottom: isMobile ? "5px" : "10px",
              }}
            ></div>
          </div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The IE Code application process is governed by the DGFT, requiring
            submission of necessary documents. Upon approval, the code is issued
            within 15-20 working days, facilitating trade with the Indian Customs
            department.
          </p>

          {/* Duration Policy */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Duration Policy
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            IE Code registration is a permanent, lifetime registration, valid as
            long as the business operates or until revoked or surrendered. No
            annual filings or renewals are required, unlike GST or PF
            registrations.
          </p>

          {/* Exemption Criteria */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Exemption Criteria
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Exemptions from IE Code apply to central government agencies or
            undertakings for defense purposes, as listed under the Foreign Trade
            (Exemption from Application of Rules in Certain Cases) Order, 1993,
            and individuals importing/exporting goods for personal use.
          </p>

          {/* Application Procedure */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Application Procedure
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            As per Para 2.08 of the Handbook of Procedure (amended via Public
            Notice No. 27/2015-2020, dated 8th August 2018), exporters/importers
            must file an online application in Form ANF 2A, submitting only
            address proof and a pre-printed cheque or bank certificate.
          </p>

          {/* Address Verification */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Address Verification
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Acceptable address proofs include a sale deed (self-owned premises),
            rental/lease agreement, latest electricity/landline/mobile bill, or
            GST registration certificate. For proprietorships, Aadhar card, Voter
            ID, or Passport in the proprietor’s name is valid (Trade Notice No.
            39/2018-19).
          </p>

          {/* Document Checklist */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Document Checklist
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Required documents vary by entity type:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Proprietorship:</strong> Proprietor’s digital photograph, PAN
              card, identity proof (Passport/Voter ID/Driving Licence/Aadhar),
              address proof, bank certificate/cancelled cheque.
            </li>
            <li>
              <strong>Partnership Firm:</strong> Managing Partner’s photograph,
              entity PAN, Managing Partner’s identity proof, partnership deed,
              address proof, bank certificate/cancelled cheque.
            </li>
            <li>
              <strong>LLP/Private Limited/Section 8 Company:</strong> Designated
              Partner/Director’s photograph, entity PAN, Director’s identity
              proof, Certificate of Incorporation, address proof, bank
              certificate/cancelled cheque.
            </li>
            <li>
              <strong>Society/Trust:</strong> Signatory’s photograph, entity PAN,
              Secretary/Chief Executive’s identity proof, registration
              certificate/trust deed, address proof, bank certificate/cancelled
              cheque.
            </li>
            <li>
              <strong>HUF:</strong> Karta’s photograph, Karta’s PAN, Karta’s
              identity proof, address proof, bank certificate/cancelled cheque.
            </li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Documents must be uploaded in digital format (GIF/JPEG, max 5MB), with
            cheques requiring a pre-printed name (Trade Notice No. 39/2018-19).
          </p>

          {/* Bank Validation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Bank Validation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A bank certificate or cancelled cheque with the pre-printed account
            holder’s name (savings or current account) is mandatory. Non-compliance
            renders the document invalid.
          </p>

          {/* Issuance Protocol */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Issuance Protocol
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Upon submission with fees and documents, the IE Code is auto-generated,
            with intimation sent via SMS/email and a downloadable e-IEC link.
            Profile updates are required post-issuance and annually (Para 2.15,
            Handbook of Procedure, 2015-2020).
          </p>

          {/* Verification Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Verification Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Regional Authority conducts post-verification of online IECs.
            Incorrect or incomplete information may lead to penal/criminal action,
            suspension, or cancellation of the code.
          </p>

          {/* RCMC Overview */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            RCMC Overview
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The Registration-Cum-Membership Certificate (RCMC), issued for five
            years by Export Promotion Councils or commodity boards, validates
            exporters dealing with registered products, requiring a declaration of
            mainstream business in the application.
          </p>

          {/* Compliance Updates */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Updates
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Businesses must update their IEC profile annually or upon changes to
            maintain validity, ensuring adherence to DGFT guidelines to avoid
            deactivation.
          </p>

          {/* Concluding Summary */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Summary
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
              marginBottom: isMobile ? "5px" : "10px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The IE Code registration process, managed by DGFT, provides a lifelong
            trade identifier for Indian businesses, with clear documentation and
            verification steps to ensure compliance and operational continuity.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ImporterExporterCodeIndia;